import { FILTER_RESET_SELECTION_EMPLOYEE } from "../../../../enums/Employees/employees.types";

export const filterResetSelectionEmployeeAction = () => {
    return {
        type: FILTER_RESET_SELECTION_EMPLOYEE,
    };
};